import {
    IProps,
} from './types';

import classNames from 'classnames';
import React, {
    FC,
} from 'react';

import {
    UPI_DEEPLINK_TYPE,
} from 'entities/payment-methods/constants';

import {
    PrimaryButton,
} from 'components/buttons';
import {
    QR,
} from 'components/other';

import DeepLinkButton from './DeepLinkButton';

import styles from './UpiIntentQr.module.scss';

const UpiIntentQr: FC<IProps> = (props) => {
    if (!props.payment?.formUrl) {
        return null;
    }

    return (
        <div className={classNames(styles.upiIntentQr, props.className)}>
            <div className={styles.content}>
                <QR
                    className={styles.qr}
                    text={props.payment.formUrl}
                />
                <div className={styles.deepLinkButtons}>
                    {
                        props.payment.deepLink?.upi &&
                        <DeepLinkButton
                            type={UPI_DEEPLINK_TYPE.UPI}
                            value={props.payment.deepLink.upi}
                        />
                    }
                    {
                        props.payment.deepLink?.paytm &&
                        <DeepLinkButton
                            type={UPI_DEEPLINK_TYPE.PAYTM}
                            value={props.payment.deepLink.paytm}
                        />
                    }
                    {
                        props.payment.deepLink?.phonepe &&
                        <DeepLinkButton
                            type={UPI_DEEPLINK_TYPE.PHONEPE}
                            value={props.payment.deepLink.phonepe}
                        />
                    }
                    {
                        props.payment.deepLink?.gpay &&
                        <DeepLinkButton
                            type={UPI_DEEPLINK_TYPE.GPAY}
                            value={props.payment.deepLink.gpay}
                        />
                    }
                </div>
            </div>
            <PrimaryButton
                className={styles.iPaidButton}
                text={'I Paid'}
                onClick={props.onPending}
            />
        </div>
    );
};

export default UpiIntentQr;
